import { render } from "./ResourcesSummary.vue?vue&type=template&id=489d87d6&scoped=true"
import script from "./ResourcesSummary.vue?vue&type=script&lang=js"
export * from "./ResourcesSummary.vue?vue&type=script&lang=js"

import "./ResourcesSummary.vue?vue&type=style&index=0&id=489d87d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489d87d6"]])

export default __exports__